<template>
    <span :cms_valuefrom="valuefrom" :cms_valueto="valueto" :cms_speed="speed" :cms_incvalue="incvalue" v-observe-visibility="visibilityChanged">{{countervalue}}</span>
</template>

<script>

import Vue from 'vue'
import { setTimeout } from 'timers';
import { clearTimeout } from 'timers';


export default {
  name: 'grccms_counter',
  components: {

  },
  props: {
    cms_valuefrom: String,
    cms_valueto: String,
    cms_speed: String,
    cms_incvalue: String
  },

  data () {
        return {
            valuefrom: this.cms_valuefrom,
            valueto: this.cms_valueto,
            speed: this.cms_speed,
            incvalue: this.cms_incvalue,
            countervalue:"0",
            intervalref:null,
        }
  },
  model: {

  },  
  methods:{

    visibilityChanged (isVisible, entry)
    {
        //console.log(isVisible);

        if (isVisible)
        {
            //console.log(this.valuefrom+" "+this.valueto+" "+this.speed+" "+this.incvalue);
            this.countervalue = parseInt(this.valuefrom);
            this.intervalref = setInterval(this.ChangeCounter , this.speed); 
        }
        
    },

    ChangeCounter()
    {
        let v = parseInt(this.countervalue);
        let i = parseInt(this.incvalue);
        if (v + i < parseInt(this.valueto)) { v =  v + i; }
        else 
        { 
            v = parseInt(this.valueto); 
            clearInterval(this.intervalref);
            this.intervalref = null;
        }

        this.countervalue = v;
        
    },


  },

  created()
  {
    if (typeof this.valuefrom == "undefined")
    {
      this.valuefrom = "";
    }

    if (typeof this.valueto == "undefined")
    {
      this.valueto = "";
    }

    if (typeof this.speed == "undefined")
    {
      this.speed = "";
    }

    if (typeof this.incvalue == "undefined")
    {
      this.incvalue = "";
    }

  },

 mounted()
 {
    
 },


}


</script>


<style scoped>


</style>
